import { createSlice } from '@reduxjs/toolkit';
import { fetchAllRecyclers } from './RecyclersThunks';

const initialState = {
  data: [],
  isFetching: false,
  error: null,
};

export const RecyclersSlice = createSlice({
  name: 'recyclers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllRecyclers.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(fetchAllRecyclers.fulfilled, (state, action) => {
        state.isFetching = false;
        state.error = null;
        state.data = action.payload;
      })
      .addCase(fetchAllRecyclers.rejected, (state) => {
        state.isFetching = false;
        state.error = 500;
      });
  },
});

export default RecyclersSlice.reducer;
